export default __webpack_public_path__ + "static/styles-dropdown-custom-5c78413c67c837caa2ca677889c2644b.png";